// import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'

// export function getToken() {
//   return Cookies.get(TokenKey)
// }

// export function setToken(token) {
//   return Cookies.set(TokenKey, token)
// }

// export function removeToken() {
//   return Cookies.remove(TokenKey)
// }


export function getToken() {
  return localStorage.getItem('KAKASHINE_TOKEN')
}

export function setToken(token) {
  return localStorage.setItem('KAKASHINE_TOKEN', token)
}

export function removeToken() {
  localStorage.removeItem('KAKASHINE_TOKEN')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js